"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.limitBasedBackoff = limitBasedBackoff;
async function limitBasedBackoff(remainingTimeInMs, remainingCalls, logger) {
    const waitMs = remainingCalls > 0
        ? remainingTimeInMs / remainingCalls
        : // in case there are no remaining calls left we will wait for the all remaining time
            remainingTimeInMs;
    logger.log({
        message: "Limit based backoff",
        payload: {
            remainingTimeInMs,
            remainingCalls,
            waitMs,
        },
    });
    await new Promise((r) => setTimeout(r, waitMs));
}
//# sourceMappingURL=limit-based-backoff.js.map